"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBanned = function SvgBanned(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 23"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.643 13.678C.603 12.666.58 12.03.57 11.77c-.058-1.44.795-2.505 2.561-3.198 2.65-1.04 10.053-2.493 20.103.206 2.364.454 3.368 1.943 3.16 3.272-.138.886-.262 1.744-.372 2.573-.24 1.035-1.005 1.435-2.293 1.2-1.933-.352-1.288-.265-2.837-.582-1.549-.317-1.397-.448-2.1-2.175-.701-1.726-.278-2.158-2.645-2.254-1.578-.064-3.666-.082-6.265-.054-.918-.045-1.483.5-1.695 1.636-.317 1.703-.707 2.08-2.517 2.43a29.29 29.29 0 0 1-3.464.472C1.204 15.23.683 14.69.643 13.678zM2.236.607l21.557 21.24",
    fill: "none",
    stroke: "#FFF"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBanned);
var _default = exports["default"] = Memo;